// extracted by mini-css-extract-plugin
export default {"content":"Documents_content__NZU8N","header":"Documents_header__Bym1h"};